import { useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { ConfigContext } from 'src/configContext';
import { Button } from 'src/common/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { PATHS } from 'src/types/Paths';

type Props = {
    isActuatorUnit: boolean;
    searchParams: URLSearchParams;
    fullWidth?: boolean;
}

export const ValvesSelectValveButton = ({
    isActuatorUnit,
    searchParams,
    fullWidth,
}: Props) => {
    const { gaPush } = useContext(ConfigContext);
    const onClick = useCallback(() => {
        gaPush({
            event: 'gaEvent',
            eventCategory: 'sizing tool',
            eventAction: 'step 3 - valve selection',
            eventLabel: 'select this valve',
        });
    }, [gaPush]);

    return (
        <Button
            onClick={onClick}
            className="vss-valves-select-valve-button"
            fullWidth={fullWidth}
            size="md"
            as={Link}
            to={{
                pathname: isActuatorUnit ? PATHS.Accessories : PATHS.Actuators,
                search: searchParams.toString(),
            }}
            icon={(
                <div className="vss-valves-select-valve-button__icon">
                    <ArrowRightIcon/>
                </div>
            )}
        >
            <I18n messageId={MESSAGES.selectDevice}/>
        </Button>
    );
};
